<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="back()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ (state != null ? 'General.Back' : 'General.Cancel') | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title style="font-size: 13px; text-align: left; margin-left: 10px !important;">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">

  @if(!this.setting.configuration.uIoptions.allinOneAuthPage) {
    @if (state == null) {
      <div class="default-content">
        <!--<img [class.full-logo]="!isLoeufrierLogo()" [class.full-logo-oeufrier]="isLoeufrierLogo()" class="center-block" logo />-->
        <img [class.full-logo]="!isLoeufrierLogo()" [class.full-logo-oeufrier]="isLoeufrierLogo()" class="center-block" [src]="logo" />
        <br>
        <h1 class="text-center" style="margin: 0;">{{'Auth.ProceedGuestMessage1' | translate }}</h1>
        <p class="text-center" style="margin-top:0;">{{'Auth.ProceedGuestMessage2' | translate }}</p>
        <ion-button expand="block" (click)="goToLogin()">{{'Auth.Login' | translate }}</ion-button>
        <div class="login-register-seperator"></div>
        <ion-button expand="block" (click)="continueAsGuest()">{{'Auth.ContinueAsGuest' | translate }}</ion-button>
        <p class="text-center">
          {{ 'Auth.LoginAgreementMessageNoRegister' | translate}}
          <a class="notice-link" (click)="termsOfUse()">{{ 'Auth.TermsOfUse' | translate }}</a> {{ 'General.And' | translate | lowercase }} <a class="notice-link" target="_system" [href]="privacyPolicyUrl">{{ 'Auth.PrivacyPolicy' | translate }}</a>
        </p>
      </div>
    }
    
    

    @if (state == 'login') {
      <div>
        <auth-login [selfManage]="true" (onLogin)="onLogin()" (onForgotPasswordClicked)="onForgotPasswordClicked()"></auth-login>
      </div>
    }
  } @else {
    <div>
      <app-all-in-one-auth-page [guestOption]="true" [unchangeUrl]="true" (continueAsGuest)="continueAsGuest()" (onLoginAllinOne)="onLoginAllinOne()" (notLoginAllinOne)="notLoginAllinOne()"></app-all-in-one-auth-page>
    </div>
  }
  
</ion-content>